import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import store, { initMiddleware } from './redux/store';

// Styling
import './stylesheets/main.scss';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://571cfbe2a87e42de80988a08003da1bf@o1249423.ingest.sentry.io/6410070',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.7,
  enabled: process.env.NODE_ENV !== 'development',
  // Errors consuming lots of quota and does not appear to be harmful.
  ignoreErrors: [
    'Highcharts error #16',
    'Highcharts error #13',
    'hbspt is not defined',
    "Cannot read properties of undefined (reading 'chart')",
    "Cannot read properties of undefined (reading 'length')"
  ]
});

// Components
import App from './containers/App';

initMiddleware();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);
